module.exports = __webpack_public_path__ + "static/media/aslThumbnail2.a1f9792b.jpg";